import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

const HandoutVisibilitySwitch = styled(Switch)(({ theme }) => ({
    width: 38.459,
    height: 20.744,
    padding: 0,
    display: 'flex',
    '& .MuiSwitch-switchBase': {
        padding: 0,
        color: '#616063',
        '&.Mui-checked': {
            transform: 'translateX(17.555px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: '#E6E6E6',
            },
            '& .MuiSwitch-thumb': {
                background: 'linear-gradient(131.61deg, #FA96C3 -2.07%, #FF669B 15.82%, #BD8DE8 116.64%)',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        width: 20.744,
        height: 20.744,
        backgroundColor: '#616063',
        boxShadow: 'none',
    },
    '& .MuiSwitch-track': {
        width: '100%',
        height: '100%',
        opacity: 1,
        borderRadius: 10.372,
        backgroundColor: '#E6E6E6',
        boxSizing: 'border-box',
    },
    [theme.breakpoints.down('sm')]: {
        width: 34,
        height: 18.36,
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(15.64px)',
        },
        '& .MuiSwitch-thumb': {
            width: 18.36,
            height: 18.36,
        },
        '& .MuiSwitch-track': {
            borderRadius: 9.18,
        },
    },
}));

export const handoutVisibilityToggleSx = {
    ml: 0,
    mr: 0,
    gap: { xs: '8px', sm: '10px' },
    '& .MuiFormControlLabel-label': {
        color: '#000453',
        fontFamily: 'Inter',
        fontSize: { xs: '14px', sm: '16px' },
        fontWeight: 400,
        lineHeight: { xs: '18px', sm: '20px' },
    },
};

export default HandoutVisibilitySwitch;
